import { useCallback } from 'react';
import { useNativeMembersQuery } from 'queries/members';

export const useTeamDetail = () => {
  const { data: memberData, isLoading: isTeamsLoading } =
    useNativeMembersQuery();

  const getTeamById = useCallback(
    (teamId: number) => {
      const teams = memberData?.teams;

      const teamObject = teams?.find(
        (teamModel) => teamModel.teamId === teamId,
      );

      return teamObject;
    },
    [memberData],
  );

  return { isTeamsLoading, getTeamById };
};
